import axios from "axios";
import React, { useState } from "react";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axiosRetry from "axios-retry";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import MaskedInput from "react-maskedinput";
import { useField } from "formik";
import { useMediaQuery } from "react-responsive";
import USWDSTable from "./USWDSTable";

// Create an instance of Axios with default configuration
const token = localStorage.getItem("token");
const cpc_db_connect = localStorage.getItem("cpc_db");

const axiosInstance = axios.create({
  // baseURL: import.meta.env.VITE_APP_MEDIA_URL,
  // baseURL: "http://tax-management.local",
  baseURL: "http://103.251.215.17:8090",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "X-CPC-Connect": cpc_db_connect,
  },
  timeout: 30000, // Set a timeout of 10 seconds
});

axiosRetry(axiosInstance, {
  retries: 2,
  retryCondition: axiosRetry.isRetryableError,
});

export const getData = async (endpoint) => {
  try {
    const response = await axiosInstance.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error(`Failed to fetch data from ${endpoint}: ${error.message}`);
  }
};

// export const formatCurrency = (value) => {
//     if (value === null || value === undefined || isNaN(value)) return "";

//     // Convert value to a number
//     const numberValue = Number(value);

//     // Create a formatter for U.S. currency
//     const formatter = new Intl.NumberFormat('en-US', {
//         style: 'currency',
//         currency: 'USD',
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//     });

//     // Format the number
//     return formatter.format(numberValue);
// };

// export const unformatCurrency = (value) => {
//     if (!value) return "";

//     // Remove the currency symbol and commas
//     return value.replace(/[^0-9.-]+/g, '');
// };

export const formatCurrency = (value) => {
  if (!value) return "";
  // Format the value as currency with dot as decimal separator
  return parseFloat(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const unformatCurrency = (value) => {
  if (!value) return "";
  // Remove any non-numeric characters (except dot) and parse it as a float
  return parseFloat(value.replace(/,/g, "")).toString();
};

export const postData = async (endpoint, data) => {
  try {
    const response = await axiosInstance.post(endpoint, data);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      // Handle 422 Unprocessable Entity error
      toast.error(error.response.data.message);
    } else {
      // Handle other errors
      console.error("Error posting data:", error);
    }

    throw new Error(`Failed to post data to ${endpoint}: ${error.message}`);
  }
};

export const downloadFile = async (fileType, values) => {
  if (fileType === "csv") {
    const months = Object.keys(values.tax_head);
    const currentMonth = months[months.length - 1];
    const headers = [
      "Tax Head Type",
      "Tax Head",
      ...Object.keys(values.tax_head),
      "Total",
    ];
    const csvRows = [];
    csvRows.push(headers.join(","));

    Object.keys(values.tax_head[currentMonth] || {}).forEach((category) => {
      values.tax_head[currentMonth][category].forEach((item, itemIndex) => {
        const row = [];
        if (itemIndex === 0) row.push(category);
        else row.push("");
        row.push(Object.keys(item)[0]);

        Object.keys(values.tax_head).forEach((month) => {
          row.push(
            values.tax_head[month]?.[category]?.[itemIndex]?.[
              Object.keys(item)[0]
            ] || 0
          );
        });

        const rowTotal = Object.keys(values.tax_head).reduce((sum, month) => {
          return (
            sum +
            parseFloat(
              values.tax_head[month]?.[category]?.[itemIndex]?.[
                Object.keys(item)[0]
              ] || 0
            )
          );
        }, 0);
        row.push(rowTotal.toFixed(2));

        csvRows.push(row.join(","));
      });

      const subcategoryTotal = Object.keys(values.tax_head).map((month) => {
        return values.tax_head[month]?.[category]
          ?.reduce((sum, item) => {
            return sum + parseFloat(item[Object.keys(item)[0]] || 0);
          }, 0)
          .toFixed(2);
      });

      csvRows.push([, "Tax Head Total", ...subcategoryTotal].join(","));
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    saveAs(blob, "tax-head-data.csv");
  } else if (fileType === "pdf") {
    const input = document.querySelector(".tax-head-data");

    // Simplify styles before capturing the screenshot
    input.style.backgroundColor = "#ffffff"; // Simple white background
    input.style.color = "#000000"; // Simple black text

    // Remove other complex styles if necessary
    // Example: input.style.border = '1px solid #000';

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "pt", "a4");
        const imgWidth = 595.28;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        pdf.save("tax-head-data.pdf");

        // Restore original styles if needed
        // Example: input.style.border = '';
      })
      .catch((error) => {
        console.error("Failed to generate PDF:", error);
      });
  }
};

// // Function to make a GET request
// export const getData = async (endpoint) => {
//     try {
//         const token = localStorage.getItem("token");
//         const cpc_db_connect = localStorage.getItem("cpc_db");

//         const axiosInstance = axios.create({
//             baseURL: import.meta.env.VITE_APP_MEDIA_URL,
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//                 "X-CPC-Connect": cpc_db_connect,
//             },
//         });

//         const response = await axiosInstance.get(endpoint);
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching data:", error);
//         throw error;
//     }
// };

// // Function to make a POST request
// export const postData = async (endpoint, data) => {
//     try {
//         const token = localStorage.getItem("token");
//         const cpc_db_connect = localStorage.getItem("cpc_db");

//         const axiosInstance = axios.create({
//             baseURL: import.meta.env.VITE_APP_MEDIA_URL,
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//                 "X-CPC-Connect": cpc_db_connect,
//             },
//         });

//         const response = await axiosInstance.post(endpoint, data);
//         return response.data;
//     } catch (error) {
//         console.error("Error posting data:", error);
//         throw error;
//     }
// };

// export const CustomSelect = ({
//     field,
//     form,
//     menuPosition,
//     options,
//     ...rest
// }) => {
//     const customStyles = {
//         option: (provided, state) => ({
//             ...provided,
//             color: state.isSelected ? "white" : "#000",
//             backgroundColor: state.isSelected ? "blue" : "white",
//         }),
//         control: (provided, state) => ({
//             ...provided,
//             height: "44px",
//             backgroundColor: "#f8fafc",
//         }),
//     };
//     const onChange = (option) => {
//         form.setFieldValue(field.name, option ? option.value : ""); // Extract and set only the value
//     };
//     const getValue = () => {
//         return options?.find((option) => option.value === field.value);
//     };

//     return (
//         <React.Fragment>
//             <Select
//                 menuPosition={menuPosition ? menuPosition : "fixed"}
//                 {...field.name}
//                 {...rest}
//                 value={getValue()}
//                 onChange={onChange}
//                 options={options}
//                 styles={customStyles}
//                 // selectedValue={label:'USA', value: 'usa'}
//             />
//         </React.Fragment>
//     );
// };

// import React from "react";
// import Select from "react-select";

// export const CustomSelect = ({
//     field,
//     form,
//     options,
//     isMulti = false,
//     menuPosition,
//     disabled = false,
//     ...rest
// }) => {
//     const customStyles = {
//         option: (provided, state) => ({
//             ...provided,
//             color: state.isSelected ? "white" : "#000",
//             backgroundColor: state.isSelected ? "blue" : "white",
//         }),
//         control: (provided, state) => ({
//             ...provided,
//             height: "44px",
//             backgroundColor: disabled ? "#e0e0e0" : "#f8fafc",
//             cursor: disabled ? "not-allowed" : "default",
//             opacity: disabled ? 0.6 : 1,
//         }),
//     };

//     const onChange = (option) => {
//         if (disabled) {
//             return;
//         }
//         if (isMulti) {
//             form.setFieldValue(
//                 field.name,
//                 option ? option.map((item) => item.value) : []
//             );
//         } else {
//             form.setFieldValue(field.name, option ? option.value : "");
//         }
//     };

//     const getValue = () => {
//         if (isMulti) {
//             return options
//                 ? options.filter((option) =>
//                       field.value?.includes(option.value)
//                   )
//                 : [];
//         } else {
//             return options
//                 ? options.find((option) => option.value === field.value)
//                 : null;
//         }
//     };

//     return (
//         <Select
//             {...field}
//             {...rest}
//             menuPosition={menuPosition ? menuPosition : "fixed"}
//             value={getValue()}
//             onChange={onChange}
//             options={options}
//             styles={customStyles}
//             isMulti={isMulti}
//             isDisabled={disabled}
//         />
//     );
// };

export const CustomSelect = ({
  field,
  form,
  options,
  isMulti = false,
  menuPosition,
  disabled = false,
  onChange: customOnChange,
  ...rest
}) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "#000",
      backgroundColor: state.isSelected ? "blue" : "white",
      padding: "6px 10px", // less padding
      fontSize: "14px",
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px", // reduced height
      height: "36px",
      backgroundColor: disabled ? "#e0e0e0" : "#f8fafc",
      cursor: disabled ? "not-allowed" : "default",
      opacity: disabled ? 0.6 : 1,
      border: "1px solid #ccc",
      borderRadius: "4px",
      boxShadow: "none",
      padding: 0,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
      minHeight: "36px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "36px",
      padding: "0 4px",
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      lineHeight: "1.2",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const handleChange = (option) => {
    if (disabled) {
      return;
    }
    if (isMulti) {
      form.setFieldValue(
        field.name,
        option ? option.map((item) => item.value) : []
      );
    } else {
      form.setFieldValue(field.name, option ? option.value : "");
    }
    if (customOnChange) {
      customOnChange(option); // Trigger custom onChange handler
    }
  };

  const getValue = () => {
    if (isMulti) {
      return options
        ? options.filter((option) => field.value?.includes(option.value))
        : [];
    } else {
      return options
        ? options.find((option) => option.value === field.value)
        : null;
    }
  };

  return (
    <Select
      {...field}
      {...rest}
      menuPosition="fixed"
      menuPlacement="auto"
      menuPortalTarget={document.body}
      value={getValue()}
      onChange={handleChange}
      options={options}
      styles={{
        ...customStyles,
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      isMulti={isMulti}
      isDisabled={disabled}
    />
  );
};

// import React, { useState } from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import './CustomDataGrid.css'; // Ensure this path is correct

// export const CustomDataGrid = ({
//     rows = [],  // Default value of an empty array
//     columns,
//     pageSizeOptions = [ 10, 15, 20, 50 ],
//     ...rest
// }) => {
//     const [ searchQuery, setSearchQuery ] = useState('');

//     // Ensure rows is an array before filtering
//     const filteredRows = Array.isArray(rows)
//         ? rows.filter(row =>
//             columns.some(col =>
//                 row[ col.field ]?.toString().toLowerCase().includes(searchQuery.toLowerCase())
//             )
//         )
//         : [];

//     const initialState = {
//         pagination: {
//             paginationModel: { page: 0, pageSize: pageSizeOptions[ 0 ] },
//         },
//     };

//     const getRowClassName = (params) => {
//         return params?.row?.file_status === 'disapproved' ? 'red-background' : '';
//     };

//     const handleClearFilter = () => {
//         setSearchQuery('');
//     };

//     return (
//         <React.Fragment>

//             {/* <div>
//                 <div style={{ marginBottom: 10, textAlign: 'end' }}>
//                     <input
//                         type="text"
//                         placeholder="Search..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         style={{
//                             padding: 5,
//                             border: '2px solid var(--primaryBgColor)',
//                             borderRadius: '5px'
//                         }}
//                     />
//                     <Button
//                         onClick={handleClearFilter}
//                         style={{ marginLeft: 10, padding: 5 }}
//                     >
//                         Clear Filter
//                     </Button>
//                 </div>
//             </div> */}
//             <DataGrid
//                 rows={filteredRows}
//                 columns={columns}
//                 pageSizeOptions={pageSizeOptions}
//                 initialState={initialState}
//                 getRowHeight={() => 'auto'}
//                 getRowClassName={getRowClassName}
//                 // className="custom-header"
//                 {...rest}
//             />
//         </React.Fragment>
//     );
// };

export const CustomDataGrid = ({
  rows = [],
  columns,
  isLoding = false,
  pageSizeOptions = [15, 20, 50, 100],
  searchQuery = "", // Accept searchQuery as a prop
  onSearchChange, // Accept onSearchChange as a prop
  checkboxSelection = false,
  onSelectionModelChange,
  ...rest
}) => {
  // Ensure rows is an array before filtering
  const isMobile = useMediaQuery({ query: "(max-width: 450px)" });
  const filteredRows = Array.isArray(rows)
    ? rows.filter((row) =>
        columns.some((col) =>
          row[col.field]
            ?.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        )
      )
    : [];
  const sortModal = columns?.map((column) => ({
    field: column.field,
    sort: "asc",
  }));
  const initialState = {
    pagination: {
      paginationModel: { page: 0, pageSize: pageSizeOptions[0] },
    },
    // sorting: {
    //     sortModel: sortModal
    // }
  };

  const getRowClassName = (params) => {
    return params?.row?.file_status === "disapproved" ? "red-background" : "";
  };

  const handleRowClick = (event) => {
    // Prevent row selection if clicked element is not a checkbox
    if (!event?.target?.closest(".MuiCheckbox-root")) {
      event.stopPropagation();
    }
  };

  return (
    <>
      <USWDSTable
        rows={filteredRows}
        columns={columns}
        isLoading={isLoding}
        checkboxSelection={true}
        onRowClick={handleRowClick}
        onSelectionModelChange={onSelectionModelChange}
      />
    </>
  );
};

//   export default CustomDataGrid;
// export const CustomDataGrid = ({
//     rows,
//     columns,
//     paginationModel,
//     pageSizeOptions,
//     ...rest
// }) => {
//     return (
//         <DataGrid
//             rows={rows}
//             columns={columns}
//             pagination
//             pageSize={paginationModel?.pageSize || 10}
//             page={paginationModel?.page || 0}
//             onPageChange={(newPage) =>
//                 paginationModel?.onPageChange &&
//                 paginationModel.onPageChange(newPage)
//             }
//             rowsPerPageOptions={pageSizeOptions || [5, 10, 15, 20]}
//             {...rest}
//         />
//     );
// };

export const MaskedInputField = ({ label, mask, ...props }) => {
  const [field, meta, helpers] = useField(props);

  return (
    <div>
      {label && <label htmlFor={props.id || props.name}>{label}</label>}
      <MaskedInput
        {...field}
        {...props}
        mask={mask}
        value={field.value || ""}
        onChange={(e) => helpers.setValue(e.target.value)}
        onBlur={field.onBlur}
      />
      {meta.touched && meta.error ? (
        <div className="error-msg">{meta.error}</div>
      ) : null}
    </div>
  );
};

const CustomQuillEditor = ({ field, form, ...props }) => {
  const handleChange = (value) => {
    form.setFieldValue(field.name, value);
  };

  return (
    <div>
      <ReactQuill
        value={field.value}
        onChange={handleChange}
        {...props}
        className="custom-quill-editor"
      />
      {/* {form.errors[field.name] && form.touched[field.name] && (
                <div className="error">{form.errors[field.name]}</div>
            )} */}
    </div>
  );
};

export default CustomQuillEditor;
